import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeContext } from '../../contexts/theme-context';
import NavbarUI from '../core-ui/navbar/navbar-ui';

export const navLinks = [
  { id: 'about', label: 'About' },
  { id: 'experience', label: 'Experience' },
  { id: 'skills', label: 'Skills' },
  { id: 'projects', label: 'Projects' },
  { id: 'education', label: 'Education' },
  { id: 'contacts', label: 'Contact' },
];

const Navbar = () => {
  const { setHandleDrawer } = useContext(ThemeContext);
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('');

  const toggleMenu = () => {
    setOpen((value) => !value);
    setHandleDrawer();
  };

  const closeMenu = () => {
    setOpen((value) => {
      if (value) setHandleDrawer();
      return false;
    });
  };

  // Shadow/border once the page has scrolled under the bar.
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Escape closes the mobile menu.
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && closeMenu();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // Scroll-spy: highlight the section currently in the middle of the viewport.
  useEffect(() => {
    if (pathname !== '/' || !('IntersectionObserver' in window)) {
      setActive('');
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id === 'top' ? '' : entry.target.id);
        });
      },
      { rootMargin: '-45% 0px -50% 0px' }
    );
    ['top', ...navLinks.map(({ id }) => id)].forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [pathname]);

  return (
    <NavbarUI
      links={navLinks}
      active={active}
      open={open}
      scrolled={scrolled}
      toggleMenu={toggleMenu}
      closeMenu={closeMenu}
    />
  );
};

export default Navbar;
